// import React, { useState } from "react";
// import instance from "../../../api/api";
// import InputCreate from "../../../features/InputCreate";

// import Swal from "sweetalert2";
// import withReactContent from "sweetalert2-react-content";
// // import { useNavigate } from "react-router-dom";
// import Button from "../../../features/Button";
// // import { FaArrowLeft } from "react-icons/fa";
// // import { MultiSelect } from "primereact/multiselect";
// // import Password from "antd/es/input/Password";
// import { Header } from "../../../shared/compoments";
// // import { Upload } from 'antd';
// function CreateProprietaire() {
//   // const navigate = useNavigate();
//   const styleBtn = {
//     padding: ".5em",
//     borderRadius: "5px",
//     fontWeight: "bold",
//     cursor: "pointer",
//     color: "black",
//     backgroundColor: "rgb(255 177 47 / 99%)",
//     marginTop: "1em",
//     border: "none",
//   };
//   const MySwal = withReactContent(Swal);
//   const [filePiece, setFilePiece] = useState([]);
//   // const [images,setImages]= useState([])

//   // const onChangeForGalerie = ({ fileList: newFileList }) => {
//   //   console.log("newFileList",newFileList)
//   //   setFileList(newFileList);
//   // };

//   //  const onPreview = async (file) => {
//   //   let src = file.url;
//   //   if (!src) {
//   //     src = await new Promise((resolve) => {
//   //       const reader = new FileReader();
//   //       reader.readAsDataURL(file.originFileObj);
//   //       reader.onload = () => resolve(reader.result);
//   //     });
//   //   }
//   //   const image = new Image();
//   //   image.src = src;
//   //   const imgWindow = window.open(src);
//   //   imgWindow?.document.write(image.outerHTML);
//   // };
//   const [data, setData] = useState({
//     nom: "",
//     prenom: "",
//     email: "",
//     phone: "",
//     adresse: "",
//     profession: "",
//   });
//   // const [dataBien, setDataBien] = useState({
//   //   nom: "",
//   //   cost: "",
//   //   adresse: "",
//   //   superficie: "",
//   //   caution: "",
//   //   description: "",
//   //   municipality_id: "",
//   //   category_id: "",
//   //   nombre_pieces: "",
//   //   nombre_portes: "",
//   //   type_id: "",
//   //   proprietaire_id: "",
//   //   status: "Disponible",
//   // });
//   const [isLoading, setIsLoading] = useState(false);
//   // const [allTypes, setAllTypes] = useState([]);
//   // const [allCategorie, setAllCategorie] = useState([]);
//   // const [allMunicipalite, setAllMunicipalite] = useState([]);
//   // const [addOneRealEsate,setAddOneRealEsate]=useState(false)
//   const saveProprietaire = async (e) => {
//     e.preventDefault();
//     // let tableauImage = [];
//     console.log("RESUME DATA", data);
//     setIsLoading(true);
//     try {
//       // fileList.forEach(item=>{
//       //   const {originFileObj} = item
//       //   setImages(originFileObj)
//       // //  tableauImage.push(originFileObj)
//       // //  console.log("originFileObj",originFileObj)
//       // });

//       console.log("filePiece85", filePiece);
//       const formData = new FormData();
//       for (const element in filePiece) {
//         formData.append("path[]", filePiece[element]);
//       }
//       formData.append("nom", data.nom);
//       formData.append("prenom", data.prenom);
//       formData.append("role_id", 2);
//       formData.append("phone", data.phone);
//       formData.append("email", data.email);
//       formData.append("adresse", data.adresse);
//       formData.append("profession", data.profession);
//       // const data = {
//       //   nom: data.nom,
//       // prenom: data.prenom,
//       // role_id: 2,
//       // phone: data.phone,
//       // email: data.email,
//       // adresse: data.adresse,
//       // profession: data.profession,
//       // path:filePiece
//       // }

//       const response = await instance.post("users", formData);

//       console.log(response);
//       if (response.data.status === false) {
//         let msgError = [];
//         for (const property in response.data.message) {
//           msgError = [...msgError, response.data.message[property]];
//         }
//         MySwal.fire({
//           title: msgError,
//           icon: "info",
//           showConfirmButton: true,
//         });
//         setIsLoading(false);
//       } else {
//         // if(addOneRealEsate){
//         //     saveProprieteProprietaire(response.data.data.id)
//         // }else{
//         setData({
//           nom: "",
//           prenom: "",
//           email: "",
//           phone: "",
//           adresse: "",
//           profession: "",
//         });
//         // onChangeForGalerie({ fileList: [] })
//         MySwal.fire({
//           title: "Enregistrement reussi.",
//           icon: "success",
//           showConfirmButton: false,
//           timer: 1500,
//         });

//         setIsLoading(false);
//       }
//     } catch (error) {
//       console.log(error);
//       let msgError = [];
//       for (const property in error.response.data.message) {
//         msgError = [...msgError, error.response.data.message[property]];
//       }
//       MySwal.fire({
//         title: msgError,
//         icon: "info",
//         showConfirmButton: true,
//       });
//       setIsLoading(false);
//     }
//   };

//   // const saveProprieteProprietaire = async(dataIdProprietaire)=>{
//   //     try {
//   //         const formData = new FormData();
//   //         const tableauImage = convertirGalerie(fileList)
//   //         for (const element in tableauImage) {
//   //           formData.append("path[]", tableauImage[element]);
//   //         }
//   //       formData.append("cost", dataBien.cost);
//   //       formData.append("adresse", dataBien.adresse);
//   //       formData.append("superficie", dataBien.superficie);
//   //       formData.append("caution", dataBien.caution);
//   //       formData.append("description", dataBien.description);
//   //       formData.append("municipality_id", dataBien.municipality_id);
//   //       formData.append("category_id", dataBien.category_id);
//   //       formData.append("nombre_pieces", dataBien.nombre_pieces);
//   //       formData.append("nombre_portes", dataBien.nombre_portes);
//   //       formData.append("type_id", dataBien.type_id);
//   //       formData.append("proprietaire_id", dataIdProprietaire);
//   //         formData.append("nom", dataBien.nom);
//   //         // formData.append("statut", "Disponible");
//   //         const response = await instance.post("proprieties", formData);

//   //         console.log(response);
//   //         if (response.data.status === false) {
//   //           let msgError = [];
//   //           for (const property in response.data.message) {
//   //             msgError = [...msgError, response.data.message[property]];
//   //           }
//   //           MySwal.fire({
//   //             title: msgError,
//   //             icon: "info",
//   //             showConfirmButton: true,
//   //           });
//   //           setIsLoading(false);
//   //         } else {
//   //           setIsLoading(false);
//   //           setData({
//   //             nom: "",
//   //             prenom: "",
//   //             email: "",
//   //             phone: "",
//   //             adresse: "",
//   //             password: "",
//   //           });
//   //           setDataBien({
//   //             nom: "",
//   //             cost: "",
//   //             adresse: "",
//   //             superficie: "",
//   //             caution: "",
//   //             description: "",
//   //             municipality_id: "",
//   //             category_id: "",
//   //             nombre_pieces: "",
//   //             nombre_portes: "",
//   //             type_id: "",

//   //             proprietaire_id: "",
//   //             status: "Disponible",
//   //           });

//   //           MySwal.fire({
//   //             title: "Enregistrement reussi.",
//   //             icon: "success",
//   //             showConfirmButton: false,
//   //             timer: 1500,
//   //           });
//   //         }
//   //       } catch (error) {
//   //         console.log(error);
//   //         let msgError = [];
//   //         for (const property in error.response.data.message) {
//   //           msgError = [...msgError, error.response.data.message[property]];
//   //         }
//   //         MySwal.fire({
//   //           title: msgError,
//   //           icon: "info",
//   //           showConfirmButton: true,
//   //         });
//   //         setIsLoading(false);
//   //       }
//   // };

//   // useEffect(() => {
//   //   const listerAll = async () => {
//   //     const responseTypes = await instance.get("types");
//   //     const responseMunicipalite = await instance.get("municipalite");
//   //     const responseCategorie = await instance.get("categories");
//   //     setAllTypes(responseTypes?.data.data);
//   //     setAllCategorie(responseCategorie?.data.data);
//   //     setAllMunicipalite(responseMunicipalite?.data.data);
//   //     console.log("responseTypes", responseTypes);
//   //     console.log("responseMunicipalite", responseMunicipalite);
//   //     console.log("responseCategorie", responseCategorie);
//   //   };
//   //   listerAll();
//   // }, []);

//   return (
//     <div>
//       <Header libelle={"Enregistrer un proprietaire"} isReturn />
//       <form onSubmit={saveProprietaire} className="my-3 px-3">
//         <InputCreate
//           label="Nom"
//           typeInput="text"
//           nameInput="name"
//           active={true}
//           getValue={(e) => {
//             setData({ ...data, nom: e.target.value });
//           }}
//           dataValue={data.nom}
//         />

//         <InputCreate
//           label="Prénoms"
//           typeInput="text"
//           nameInput="text"
//           active={true}
//           getValue={(e) => {
//             setData({ ...data, prenom: e.target.value });
//           }}
//           dataValue={data.prenom}
//         />
//         <InputCreate
//           label="Email"
//           typeInput="email"
//           nameInput="email"
//           active={true}
//           getValue={(e) => {
//             setData({ ...data, email: e.target.value });
//           }}
//           dataValue={data.email}
//         />
//         <InputCreate
//           label="Téléphone"
//           typeInput="phone"
//           nameInput="phone"
//           active={true}
//           getValue={(e) => {
//             setData({ ...data, phone: e.target.value });
//           }}
//           dataValue={data.phone}
//         />
//         <InputCreate
//           label="Profession"
//           typeInput="text"
//           nameInput="text"
//           active={true}
//           getValue={(e) => {
//             setData({ ...data, profession: e.target.value });
//           }}
//           dataValue={data.profession}
//         />
//         <InputCreate
//           label="adresse"
//           typeInput="text"
//           nameInput="text"
//           active={true}
//           getValue={(e) => {
//             setData({ ...data, adresse: e.target.value });
//           }}
//           dataValue={data.adresse}
//         />
//         <div>
//           <label className="w-100 my-3">Importer la pièce d'identité</label>
//           <input
//             type="file"
//             onChange={(e) => setFilePiece(e.target.files)} // For multiple files
//             name="fileUpload"
//             id="fileUpload"
//             multiple
//           />
//           {/* <Upload
//         listType="picture-card"
//         fileList={fileList}
//         onChange={onChangeForGalerie}
//         onPreview={onPreview}
//         multiple
//       >
//         {fileList.length < 5 && "+ Importer la pièce d'identité"}
//       </Upload> */}
//         </div>

//         {/* <div className="conteneur_propriete d-flex justify-content-end">
//           <div className=" add_bien p-2 bg-primary text-light text-center"
//           onClick={()=>setAddOneRealEsate(realEsate=>realEsate = !realEsate)}
//           >
//             {
//                !addOneRealEsate ? 'Ajouter un bien +':'Fermer'
//             }
//           </div>
//         </div> */}
//         {/* {
//             addOneRealEsate &&
//             <>
//  <InputCreate
//           label="Bien"
//           typeInput="text"
//           nameInput="Nom"
//           active={true}
//           getValue={(e) => {
//             setDataBien({ ...dataBien, nom: e.target.value });
//           }}
//           dataValue={dataBien.nom}
//         />
//         <InputCreate
//           label="Lieu"
//           typeInput="text"
//           nameInput="lieu"
//           active={true}
//           getValue={(e) => {
//             setDataBien({ ...dataBien, adresse: e.target.value });
//           }}
//           dataValue={dataBien.adresse}
//         />
//         <div>
//           <label htmlFor="commune">Communes</label>
//           <select
//             name="commune"
//             id="all_categorie"
//             onChange={(e) => {
//               setDataBien({ ...dataBien, municipality_id: e.target.value });
//             }}
//             className="w-100 p-3 mb-2"
//           >
//             <option value={""} disabled selected>
//               Sélectionner une commune
//             </option>
//             {allMunicipalite.map((item) => (
//               <option key={item.id} value={item.id}>
//                 {item.name}
//               </option>
//             ))}
//           </select>
//         </div>
//         <div>
//           <label htmlFor="categories">Catégories</label>
//           <select
//             name="categories"
//             id="all_categorie"
//             onChange={(e) => {
//               setDataBien({ ...dataBien, category_id: e.target.value });
//             }}
//             className="w-100 p-3 mb-2"
//           >
//             <option value={""} disabled selected>
//               Sélectionner une catégorie
//             </option>
//             {allCategorie.map((item) => (
//               <option key={item.id} value={item.id}>
//                 {item.label}
//               </option>
//             ))}
//           </select>
//         </div>
//         <div>
//           <label htmlFor="types">Types</label>
//           <select
//             name="types"
//             id="all_Types"
//             onChange={(e) => {
//               setDataBien({ ...dataBien, type_id: e.target.value });
//             }}
//             className="w-100 p-3 mb-2"
//           >
//             <option value={""} disabled selected>
//               Sélectionner un type
//             </option>
//             {allTypes.map((item) => (
//               <option key={item.id} value={item.id}>
//                 {item.label}
//               </option>
//             ))}
//           </select>
//         </div>
//         <div>
//           <label htmlFor="description">Description</label>
//           <textarea
//             value={dataBien.description}
//             onChange={(e) => {
//               setDataBien({ ...dataBien, description: e.target.value });
//             }}
//             name="description"
//             id=""
//             cols="30"
//             rows="10"
//             className="w-100"
//           ></textarea>
//         </div>
//         <InputCreate
//           label="Prix"
//           typeInput="number"
//           minValueInput={1}
//           nameInput="Prix"
//           active={true}
//           getValue={(e) => {
//             setDataBien({ ...dataBien, cost: e.target.value });
//           }}
//           dataValue={dataBien.cost}
//         />
//         <InputCreate
//           label="Superficie"
//           typeInput="number"
//           minValueInput={1}
//           nameInput="Superficie"
//           active={true}
//           getValue={(e) => {
//             setDataBien({ ...dataBien, superficie: e.target.value });
//           }}
//           dataValue={dataBien.superficie}
//         />
//         <InputCreate
//           label="Caution"
//           typeInput="number"
//           nameInput="Caution"
//           minValueInput={1}
//           active={true}
//           getValue={(e) => {
//             setDataBien({ ...dataBien, caution: e.target.value });
//           }}
//           dataValue={dataBien.caution}
//         />
//         <InputCreate
//           label="Nombre de pièces"
//           typeInput="number"
//           minValueInput={1}
//           nameInput="Nombre de pièces"
//           active={true}
//           getValue={(e) => {
//             setDataBien({ ...dataBien, nombre_pieces: e.target.value });
//           }}
//           dataValue={dataBien.nombre_pieces}
//         />
//         <InputCreate
//           label="Nombre de portes"
//           typeInput="number"
//           minValueInput={1}
//           nameInput="Nombre de portes"
//           active={true}
//           getValue={(e) => {
//             setDataBien({ ...dataBien, nombre_portes: e.target.value });
//           }}
//           dataValue={dataBien.nombre_portes}
//         />

//       <Upload
//         listType="picture-card"
//         fileList={fileList}
//         onChange={onChangeForGalerie}
//         onPreview={onPreview}
//         multiple
//       >
//         {fileList.length < 5 && '+ Ajouter vos photos'}
//       </Upload>
//             </>
//         }
//         */}

//         <div>
//           <Button
//             titre="Enregistrer"
//             styleBtn={styleBtn}
//             isLoading={isLoading}
//           />
//         </div>
//       </form>
//     </div>
//   );
// }

// export default CreateProprietaire;

import React, { useState } from "react";
import instance from "../../../api/api";
import InputCreate from "../../../features/InputCreate";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import Button from "../../../features/Button";
import { Header } from "../../../shared/compoments";

function CreateProprietaire() {
  const styleBtn = {
    padding: ".5em",
    borderRadius: "5px",
    fontWeight: "bold",
    cursor: "pointer",
    color: "black",
    backgroundColor: "rgb(255 177 47 / 99%)",
    marginTop: "1em",
    border: "none",
  };
  const MySwal = withReactContent(Swal);
  const [filePiece, setFilePiece] = useState([]);

  const [data, setData] = useState({
    nom: "",
    prenom: "",
    email: "",
    phone: "",
    adresse: "",
    profession: "",
  });

  const [isLoading, setIsLoading] = useState(false);

  const saveProprietaire = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      const formData = new FormData();
      for (let i = 0; i < filePiece.length; i++) {
        formData.append("path[]", filePiece[i]);
      }
      formData.append("nom", data.nom);
      formData.append("prenom", data.prenom);
      formData.append("role_id", 2);
      formData.append("phone", data.phone);
      formData.append("email", data.email);
      formData.append("adresse", data.adresse);
      formData.append("profession", data.profession);

      const response = await instance.post("users", formData);

      if (response.data.status === false) {
        let msgError = [];
        for (const property in response.data.message) {
          msgError = [...msgError, response.data.message[property]];
        }
        MySwal.fire({
          title: msgError,
          icon: "info",
          showConfirmButton: true,
        });
        setIsLoading(false);
      } else {
        setData({
          nom: "",
          prenom: "",
          email: "",
          phone: "",
          adresse: "",
          profession: "",
        });
        setFilePiece([]);
        MySwal.fire({
          title: "Enregistrement réussi.",
          icon: "success",
          showConfirmButton: false,
          timer: 1500,
        });
        setIsLoading(false);
      }
    } catch (error) {
      console.log(error);
      let msgError = [];
      for (const property in error.response?.data.message) {
        msgError = [...msgError, error.response.data.message[property]];
      }
      MySwal.fire({
        title: msgError,
        icon: "info",
        showConfirmButton: true,
      });
      setIsLoading(false);
    }
  };

  return (
    <div>
      <Header libelle={"Enregistrer un propriétaire"} isReturn />
      <form onSubmit={saveProprietaire} className="my-3 px-3">
        {/* Grille Bootstrap */}
        <div className="row g-3">
          {/* Nom */}
          <div className="col-lg-4">
            <InputCreate
              label="Nom"
              typeInput="text"
              nameInput="nom"
              active={true}
              getValue={(e) => setData({ ...data, nom: e.target.value })}
              dataValue={data.nom}
            />
          </div>

          {/* Prénom */}
          <div className="col-lg-4">
            <InputCreate
              label="Prénoms"
              typeInput="text"
              nameInput="prenom"
              active={true}
              getValue={(e) => setData({ ...data, prenom: e.target.value })}
              dataValue={data.prenom}
            />
          </div>

          {/* Email */}
          <div className="col-lg-4">
            <InputCreate
              label="Email"
              typeInput="email"
              nameInput="email"
              active={true}
              getValue={(e) => setData({ ...data, email: e.target.value })}
              dataValue={data.email}
            />
          </div>

          {/* Téléphone */}
          <div className="col-lg-4">
            <InputCreate
              label="Téléphone"
              typeInput="tel"
              nameInput="phone"
              active={true}
              getValue={(e) => setData({ ...data, phone: e.target.value })}
              dataValue={data.phone}
            />
          </div>

          {/* Profession */}
          <div className="col-lg-4">
            <InputCreate
              label="Profession"
              typeInput="text"
              nameInput="profession"
              active={true}
              getValue={(e) => setData({ ...data, profession: e.target.value })}
              dataValue={data.profession}
            />
          </div>

          {/* Adresse */}
          <div className="col-lg-4">
            <InputCreate
              label="Adresse"
              typeInput="text"
              nameInput="adresse"
              active={true}
              getValue={(e) => setData({ ...data, adresse: e.target.value })}
              dataValue={data.adresse}
            />
          </div>

          {/* Pièce d'identité */}
          <div className="col-lg-4">
            <label htmlFor="fileUpload" className="form-label">
              Pièce d'identité
            </label>
            <input
              type="file"
              id="fileUpload"
              name="fileUpload"
              className="form-control"
              onChange={(e) => setFilePiece(e.target.files)}
              multiple
              accept="image/*,.pdf"
              style={{ height: "50px" }}
            />
            <small className="text-muted">Formats : JPG, PNG, PDF</small>
          </div>
        </div>

        {/* Bouton Enregistrer */}
        <div className="text-center mt-4">
          <Button
            titre="Enregistrer"
            styleBtn={styleBtn}
            isLoading={isLoading}
          />
        </div>
      </form>
    </div>
  );
}

export default CreateProprietaire;
